import { ProfessionIcon } from './profession-icon';

export const IconTutor = () => (
  <ProfessionIcon bg="#E8EAF6">
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
      <path
        d="M4 19.5A2.5 2.5 0 016.5 17H20"
        stroke="#3F51B5"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <path
        d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z"
        stroke="#3F51B5"
        strokeWidth="1.8"
      />
      <path
        d="M9 7h6M9 11h4"
        stroke="#3F51B5"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  </ProfessionIcon>
);
